import { useEffect } from "react";

// Sets a unique <title>, meta description, and canonical URL per page while mounted,
// then restores the previous values on unmount. Googlebot renders JS, so this gives
// each client-rendered route correct, non-duplicate SEO signals.
const SITE = "https://socialmediacombo.com";

export function useSeo({ title, description, path }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    // meta description
    let descEl = document.querySelector('meta[name="description"]');
    const descCreated = !descEl;
    const prevDesc = descEl ? descEl.getAttribute("content") : null;
    if (description) {
      if (!descEl) {
        descEl = document.createElement("meta");
        descEl.setAttribute("name", "description");
        document.head.appendChild(descEl);
      }
      descEl.setAttribute("content", description);
    }

    // canonical
    let linkEl = document.querySelector('link[rel="canonical"]');
    const linkCreated = !linkEl;
    const prevHref = linkEl ? linkEl.getAttribute("href") : null;
    if (path != null) {
      if (!linkEl) {
        linkEl = document.createElement("link");
        linkEl.setAttribute("rel", "canonical");
        document.head.appendChild(linkEl);
      }
      linkEl.setAttribute("href", `${SITE}${path}`);
    }

    return () => {
      document.title = prevTitle;
      if (descEl) {
        if (descCreated) descEl.remove();
        else if (prevDesc !== null) descEl.setAttribute("content", prevDesc);
      }
      if (linkEl) {
        if (linkCreated) linkEl.remove();
        else if (prevHref !== null) linkEl.setAttribute("href", prevHref);
      }
    };
  }, [title, description, path]);
}
